import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { LeftArrowIcon } from "../../../Assets/svgIcons";
import "./InfluncerEnrollment.scss";
import Step1 from "./Step1";
import Step2 from "./Step2";
import {
  getInfluencerFee,
  getInfluencerProfile,
} from "../../../Services/prod/auth.service";
import { useAuth } from "../../../Contexts/auth.context";

const InfluncerEnrollment = () => {
  // ********** STATES **********
  const {auth} = useAuth();
  const [step, setStep] = useState(1);
  const [feeData, setFeedata] = useState({});
  const [update, setUpdate] = useState(false);
  const [profileData, setProfileData] = useState({});
  const [stepOneData, setStepOneData] = useState({});

  // ********** CALL PROFILE AND FEE API **********
  const handleInfluencer = async () => {
    try {
      if(auth?.userId){
        const [resProfile, resFees] = await Promise.all([
          getInfluencerProfile(auth?.userId),
          getInfluencerFee(auth?.userId),
        ]);
        if (resProfile && resFees) {
          setProfileData(resProfile?.data);
          setFeedata(resFees?.data);
        }
      }
    } catch (error) {
      console.log(error, "error");
    }
  };
  useEffect(() => {
    handleInfluencer();
  }, [update]);

  return (
    <div className="influencer_enrollment_page">
      <Container>
        <div className="page_header">
          {step === 2 && (
            <button
              type="button"
              onClick={() => setStep(1)}
              className="back_btn"
            >
              <LeftArrowIcon />
            </button>
          )}
          <h2>Influencer Enrollment</h2>
          <div className="page_header_right"></div>
        </div>
        <div className="page_content">
          {step === 1 && (
            <Step1
              setStep={setStep}
              step={step}
              profileData={profileData}
              stepOneData={stepOneData}
              setStepOneData={setStepOneData}
            />
          )}
          {step === 2 && (
            <Step2
              feeData={feeData}
              stepOneData={stepOneData}
              profileData={profileData}
              setUpdate={setUpdate}
            />
          )}
        </div>
      </Container>
    </div>
  );
};

export default InfluncerEnrollment;
